__webpack_require__.p = "/design-tokens-update-v2/onboarding/";